import axios from "axios";
import { API_BASE_URL } from "../constants";

/**
 * Creates a new subscriber
 * @param {string} email - Subscriber's email
 * @param {string} fullName - Subscriber's full name
 * @returns {Promise<Object>} - Created subscriber data
 * @throws {Error} - With user-friendly message
 */
export const createSubscriber = async (email, fullName) => {
  try {
    const response = await axios.post(`${API_BASE_URL}api/subscribers`, {
      email,
      fullName,
    });

    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to subscribe. Please try again.";

    throw new Error(message);
  }
};
